import './teamsContext';

/**
 * Determines the source for status updates based on the current environment
 * @returns The source string to be used for status tracking
 */
export const getStatusSource = (): string => {
  const isIosApp = Boolean(window.navigator?.userAgent?.includes('Wemble(iOS)'));

  if (isIosApp) {
    return "ios_app";
  }

  const appIsInTeams = window.name === 'embedded-page-container' || window.name === 'extension-tab-frame' || (window as any).__isInTeams;
  if (appIsInTeams) {
    const hostName = (window as any).__teamsHostName; // "Teams", "teamsModern", "Outlook", "Office"
    const clientType = (window as any).__teamsClientType; // "web", "desktop", etc.
    if (hostName && clientType) {
      return `${hostName.toLowerCase()}_${clientType}`;
    }
    if (hostName) {
      return `${hostName.toLowerCase()}_app`;
    }
    if (clientType) {
      return `teams_app_${clientType}`;
    }
    return "teams_app";
  }

  return "web_app";
};
